module.exports = __webpack_public_path__ + "media/promo/courses/images/herom-d0cf78228ab53ab77651f6dad86c90a1.png";